// store/modules/filters/networkScansFilter.js

const state = {
    reportsType: null,
    countNets: 50, // set an initial value
    chosenPage: 1,
};

const mutations = {
    setReportsType(state, reportsType) {
        state.reportsType = reportsType;
    },
    setCountNets(state, countNets) {
        state.countNets = countNets;
    },
    setChosenPage(state, chosenPage) {
        state.chosenPage = chosenPage;
    },
};

const actions = {
    updateReportsType({ commit }, reportsType) {
        commit('setReportsType', reportsType);
    },
    updateCountNets({ commit }, countNets) {
        commit('setCountNets', countNets);
    },
    updateChosenPage({ commit }, chosenPage) {
        commit('setChosenPage', chosenPage);
    },
};

const getters = {
    getReportsType: (state) => state.reportsType,
    getCountNets: (state) => state.countNets,
    getChosenPage: (state) => state.chosenPage,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};